import api from "../../Utils/interceptors";

export const getAllLoanRequests =
  (page, size, requested_by = "") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_ALL_LOAN_REQUESTS_REQUEST" });
      const { data } = await api.get(
        `loan-requests/all?page=${page}&size=${size}&requested_by=${requested_by}`,
      );
      dispatch({
        type: "GET_ALL_LOAN_REQUESTS_SUCCESS",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "GET_ALL_LOAN_REQUESTS_FAILED",
        payload: error.response?.data?.message,
      });
    }
  };

export const getCurrentUserLoanRequests =
  (page, size) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_CURRENT_USER_LOAN_REQUESTS_REQUEST" });
      const { data } = await api.get(
        `loan-requests/my?page=${page}&size=${size}`,
      );
      dispatch({
        type: "GET_CURRENT_USER_LOAN_REQUESTS_SUCCESS",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "GET_CURRENT_USER_LOAN_REQUESTS_FAILED",
        payload: error.response?.data?.message,
      });
    }
  };

export const createLoanRequest = (loanData) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_LOAN_REQUEST_REQUEST" });
    const { data } = await api.post("/loan-request/create", loanData);
    dispatch({
      type: "CREATE_LOAN_REQUEST_SUCCESS",
      payload: data,
      success: true,
    });
  } catch (e) {
    dispatch({
      type: "CREATE_LOAN_REQUEST_FAILED",
      payload: e.response?.data?.message,
      success: false,
    });
  }
};

export const indivisualLoanRequestDetail = (loanId) => async (dispatch) => {
  try {
    dispatch({ type: "INDIVISUAL_LOAN_REQUEST_DETAIL_REQUEST" });
    const { data } = await api.get(`/loan-request/${loanId}`);
    dispatch({
      type: "INDIVISUAL_LOAN_REQUEST_DETAIL_SUCCESS",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "INDIVISUAL_LOAN_REQUEST_DETAIL_FAILED",
      payload: error.response?.data?.message,
    });
  }
};

export const indivisualLoanRequestDeleted = (id) => async (dispatch) => {
  try {
    dispatch({ type: "INDIVISUAL_LOAN_REQUEST_DELETE_REQUEST" });
    const { data } = await api.delete(`/loan-request/${id}`);
    dispatch({
      type: "INDIVISUAL_LOAN_REQUEST_DELETE_SUCCESS",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "INDIVISUAL_LOAN_REQUEST_DELETE_FAILED",
      payload: error.response?.data?.message,
    });
  }
};
